export { default } from './NumberInput';
export type { NumberInputProps } from './NumberInput';
